import { render, staticRenderFns } from "./ProcedureShareMailAuth.vue?vue&type=template&id=a0012738&"
import script from "./ProcedureShareMailAuth.vue?vue&type=script&lang=ts&"
export * from "./ProcedureShareMailAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports